// @flow

import * as React from "react";
// import { useSelector } from "react-redux";

import { type ImageType, type LinkType } from "../../types";

import { ReactComponent as Triangle } from "../../../assets/images/shape-triangle.svg";
import { ReactComponent as Circle } from "../../../assets/images/shape-circle.svg";
import { ReactComponent as Ring } from "../../../assets/images/shape-ring-thick-fill.svg";
import LinkHandler from "../atoms/LinkHandler";
import { PrimaryNavPad } from "./PrimaryNav";
import Image from "../atoms/Image";

type PropsType = {
    logo: ImageType,
    heading: string,
    description?: string,
    eyebrow?: string,
    image: ImageType,
    cta: LinkType,
};

const HeroSports = (props: PropsType): React.Node => {
    const baseClassName = "hero-sports";
    const classes = [baseClassName];

    return (
        <div className={classes.join(" ")}>
            <div className="hero-sports__overlay">
                <PrimaryNavPad />
                <div className="container-fluid">
                    {/* Design elements */}
                    <Circle className="hero-sports__circle-small" />
                    <Ring className="hero-sports__ring" />
                    <Triangle className="hero-sports__triangle" />
                    <div className="hero-sports__diamond" />
                    <Circle className="hero-sports__circle-small hero-sports__circle-small--desktop-only" />
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="hero-sports__top-row">
                                <div className="hero-sports__logo">
                                    <Image
                                        image={props.logo}
                                        size={"large"}
                                        alt="Sports Logo"
                                    />
                                </div>
                                <p className="hero-sports__intro">
                                    {props.description}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="hero-sports__inner">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="hero-sports__footer">
                                <div className="hero-sports__image">
                                    <Image
                                        // image={props.image}
                                        // size={"large"}
                                        src={props.image.sizes["1536x1536"]}
                                        srcset={`
                                            ${props.image.sizes["medium_large"]} 450w,
                                            ${props.image.sizes["1536x1536"]}} 600w
                                        `}
                                        alt="test"
                                        aspectRatio="3:2"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="hero-sports__footer__inner">
                                <div className="hero-sports__footer__left-content">
                                    <div className="hero-sports__footer__eyebrow">
                                        {props.eyebrow}
                                    </div>
                                    <div className="hero-sports__footer__title">
                                        {props.heading}
                                    </div>
                                </div>
                                <div className="hero-sports__footer__right-content">
                                    <LinkHandler
                                        to={props.cta.url}
                                        className="hero-sports__footer__cta button button--teal"
                                    >
                                        <span className="button__text">
                                            {props.cta.title}
                                        </span>
                                    </LinkHandler>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroSports;
